var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"data-v-327ea383":"","xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"xml:space":"preserve"}},[_c('path',{attrs:{"fill":_vm.fillColour,"d":_vm.path}})])
}
var staticRenderFns = []

export { render, staticRenderFns }